import { render, staticRenderFns } from "./AccessChannels.vue?vue&type=template&id=b95d7f96&scoped=true&"
import script from "./AccessChannels.vue?vue&type=script&lang=js&"
export * from "./AccessChannels.vue?vue&type=script&lang=js&"
import style0 from "./AccessChannels.vue?vue&type=style&index=0&id=b95d7f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95d7f96",
  null
  
)

export default component.exports